import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrashPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trash-paper"} maskId="square-filled-radius-0-stroke-1-IconTrashPaper"><path d="M14.1111 1.89917L10.7591 4.13384L3.52691 5.24648L4.07109 9.59998L2 10.6355V14.3788L3.61558 15.4559L4.14516 19.6925L7.24384 21.5517L10.8212 19.5075L12.8829 22.0847L16.4758 20.8871L21.0815 16.8571L18.9305 13.0928L22.2595 8.65414L17.7778 6.4133V4.34361L14.1111 1.89917Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrashPaper;
